var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialPlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Play Store") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/SocialPlayStore",
    fill: "#FFFFFF",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1184672,8.62873671 L14.8269109,11.9634898 L17.5476309,9.51658113 L4.77450389,2.1421227 C4.44888188,1.95395977 4.08512656,1.96318344 3.78949466,2.10786334 C3.89087601,2.15319111 3.98798811,2.21591208 4.07761586,2.29655334 L11.1184672,8.62873671",
    id: "Fill-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8269109,11.9634898 L4.07761586,2.29655334 C3.98798811,2.21591208 3.89087601,2.15319111 3.78949466,2.10786334 C3.45016891,2.27415299 3.20049725,2.61911837 3.20049725,3.05078627 L3.20049725,20.9491922 C3.20049725,21.167925 3.26469402,21.364521 3.3722684,21.5268577 C3.47657496,21.6841872 3.62130757,21.8093656 3.78786075,21.8915881 L14.8269109,11.9634898",
    id: "Fill-46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0715582,15.3409354 L3.78786075,21.8915881 C4.0838089,22.036795 4.44822304,22.0462822 4.77450389,21.8578558 L17.5969117,14.4549357 L14.8269109,11.9634898 L11.0715582,15.3409354",
    id: "Fill-47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2749393,11.0914574 L17.5476309,9.51658113 L14.8269109,11.9634898 L17.5969117,14.4549357 L20.2749393,12.9087846 C20.9743572,12.5050512 20.9743572,11.4951908 20.2749393,11.0914574",
    id: "Fill-48"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialPlayStore);
export default __webpack_public_path__ + "static/media/SocialPlayStore.0237d84c305b6b412efb27f08bf93660.svg";
export { ForwardRef as ReactComponent };